import { Textarea } from '@primer/react';
import * as React from 'react';
export default {
  Textarea,
  React
};